import { Link } from 'react-router-dom';
import { categories } from '@/mocks/posts';
import { navLinks, site } from '@/utils/site';

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-auto">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading text-2xl text-background-50">{site.name}</span>
            </div>
            <p className="text-sm leading-7 text-background-100/80 max-w-md">
              {site.description}
            </p>
            <p className="mt-4 text-xs text-background-100/60 leading-6">
              本站内容为公开播出的节目、赛事与颁奖礼片段的看点整理与文字评述，仅供信息浏览与讨论参考。
            </p>
          </div>

          <div>
            <h2 className="font-heading text-lg text-background-50 mb-4">主题分类</h2>
            <ul className="space-y-3">
              {categories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${category.slug}`}
                    className="text-sm text-background-100/80 hover:text-accent-400 transition-colors inline-flex items-center gap-1.5"
                  >
                    <i className="ri-arrow-right-s-line" />
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-lg text-background-50 mb-4">网站导航</h2>
            <ul className="space-y-3">
              {navLinks.slice(6).map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-100/80 hover:text-accent-400 transition-colors inline-flex items-center gap-1.5"
                  >
                    <i className="ri-arrow-right-s-line" />
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-background-100/80 hover:text-accent-400 transition-colors inline-flex items-center gap-1.5"
                >
                  <i className="ri-arrow-right-s-line" />
                  联系我们
                </Link>
              </li>
            </ul>
            <div className="mt-6 space-y-2">
              <p className="text-xs text-background-100/60 flex items-center gap-2">
                <i className="ri-mail-line" />
                {site.email}
              </p>
              <p className="text-xs text-background-100/60 flex items-center gap-2">
                <i className="ri-team-line" />
                {site.bizEmail}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/60">
            © 2026 {site.name} · {site.tagline}
          </p>
          <p className="text-xs text-background-100/60">
            精选内容，理性围观 · 如有内容问题欢迎留言反馈
          </p>
        </div>
      </div>
    </footer>
  );
}